import styled from 'styled-components'
import { backgroundOrange } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { panelSurface } from '@components/Card'
import { PageColumn } from '@components/Page'

export const BalancesPageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

export const LoadingContainer = styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
	align-items: center;
	background-color: ${backgroundOrange};
	height: 100%;
`


/**
 * The fluid column, as on the itinerary: the heading row stays on the shell's
 * width under the chrome's edges while the panels take the full width on the
 * shell's gutters. Unlike a scrolling page it fills the viewport and never
 * grows past it — the panels scroll inside — with a short margin under them
 * instead of the column's usual 64px.
 */
export const ContentContainer = styled(PageColumn).attrs({ $fluid: true })`
	flex: 1 1 0;
	min-height: 0;
	display: flex;
	flex-direction: column;
	padding-bottom: 24px;

	${media.phone} {
		padding-bottom: 16px;
	}
`

export const SplitLayout = styled.div`
	display: flex;
	gap: 24px;
	flex: 1;
	min-height: 0;

	${media.tabletWide} {
		display: none;
	}
`

export const MembersColumn = styled.section`
	${panelSurface}
	flex: 0 0 380px;
	min-width: 0;
	display: flex;
	flex-direction: column;
	padding: 16px 16px 16px 20px;
`

export const ActivityColumn = styled.section`
	${panelSurface}
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	padding: 16px 16px 16px 20px;
`

export const MobileLayout = styled.div`
	display: none;
	flex: 1;
	min-height: 0;
	flex-direction: column;

	${media.tabletWide} {
		display: flex;
	}
`

export const MobilePanel = styled.div<{ $active: boolean }>`
	${panelSurface}
	display: ${({ $active }) => ($active ? 'flex' : 'none')};
	flex-direction: column;
	flex: 1;
	min-height: 0;
	padding: 16px 16px 16px 20px;
`

